export default {
  SET_MEDICAL_CANCER(state, payload) {
    state.AllMedicalCancer = payload;
  },
  SET_SELECTED_MEDICAL_FOR_UPDATE(state, payload) {
    state.selectedMedicalForUpdate = payload;
  },
};
